import { formatMoney } from "@shopify/theme-currency";

/**
 * @param price {number}
 *
 * @returns {string}
 */
const pricing = (price) => {
  // if compareAtPrice is defined return compareAtPrice with pricing
  if (price != null) {
    let returnPrice = `${window.currency.symbol}${formatMoney(
      price,
      window.product.money_format
    )}`;
    // If NOK is the currency change order to symbol amount iso
    if (window.product.money_format.includes("NOK")) {
      returnPrice =
        `${window.currency.symbol}` +
        " " +
        `${formatMoney(price, window.product.money_format).replace(
          ",00",
          " "
        )}`;
    }
    // If HKD is the currency change order to symbul amount iso
    else if (window.product.money_format.includes("HK")) {
      returnPrice =
        `${formatMoney(price, window.product.money_format.split("HK")[1])
          // .replace(",00", " ")
          .replace(".00", " ")}` + "HKD";
    }
    // If CHF is the currency change order to amount and iso
    else if (window.product.money_format.includes("CHF")) {
      returnPrice =
        `${formatMoney(
          price,
          window.product.money_format.split("CHF")[1]
        ).replace(".00", " ")}` + "CHF";
    } 
    // If EUR is the currency remover ,00 and add space
    else if (window.product.money_format.includes("EUR")) {
      returnPrice = `${formatMoney(price, window.product.money_format).replace(
        ",00",
        " "
      )}`;
    } 
    // If USD is the currency remover .00 and add space
    else if (window.product.money_format.includes("$")) {
      returnPrice = `${formatMoney(price, window.product.money_format).replace(
        ".00",
        " "
      )}`;
    } 
    else if 
    // If GBP is the currency remover .00 and add space
    (window.product.money_format.includes("GBP")) {
      returnPrice = `${formatMoney(price, window.product.money_format).replace(
        ".00",
        " "
      )}`;
    }
    // If other is the currency remover ./,00 and add space
    else {
      returnPrice = `${formatMoney(price, window.product.money_format)
        .replace(",00", " ")
        .replace(".00", " ")}`;
    }

    return returnPrice;
  }
};

export { pricing };
